import axios from "axios";
import { authHeader, multipartHeader } from "./auth-header";

const getAll = (params) => {
  return axios.get(process.env.REACT_APP_API_URL + "admin/product/list", {
    headers: authHeader(),
    data: {},
    params
  });
};
const salegetAllProduct = (params) => {
  return axios.get(process.env.REACT_APP_API_URL + "sale/product/list", {
    headers: authHeader(),
    data: {},
    params
  });
};


const get = (id) => {
  return axios.get(process.env.REACT_APP_API_URL + `product/view/${id}`, {
    headers: authHeader(),
    data: {},
  });
};

const getVariant = (id) => {
  return axios.get(process.env.REACT_APP_API_URL + `productvariant/view/${id}`, {
    headers: authHeader(),
    data: {},
  });
};


const getProductByBarcode = (id = 1, data) => {
  return axios.put(process.env.REACT_APP_API_URL + `product/barcode/${id}`, data, {
    headers: authHeader(),
  });
};

const create = (data) => {
  return axios.post(process.env.REACT_APP_API_URL + `product/create`, data, {
    headers: multipartHeader(),
  });
};

const update = (id, data) => {
  return axios.put(process.env.REACT_APP_API_URL + `product/update/${id}`, data, {
    headers: multipartHeader(),
  });
};


const updateStatus = (id, data) => {
  return axios.put(
    process.env.REACT_APP_API_URL + `product/updateStatus/${id}`, data,
    {
      headers: authHeader(),
    }
  );
};

const deleteProduct = (id, data) => {
  return axios.delete(process.env.REACT_APP_API_URL + `product/delete/${id}`, {
    headers: authHeader(),
    data
  });
};

const restore = (id, data) => {
  return axios.get(process.env.REACT_APP_API_URL + `product/restore/${id}`, {
    headers: authHeader(),
    params: data
  });
};


const restoreVariant = (id, data) => {
  return axios.patch(process.env.REACT_APP_API_URL + `product/variant/restore/${id}`, {
    headers: authHeader(),
    params: data
  });
};


const updateStock = (id, data) => {
  return axios.put(
    process.env.REACT_APP_API_URL + `product/update-stock/${id}`, data,
    {
      headers: authHeader(),
    }
  );
};


const updateVariant = (id, data) => {
  return axios.post(
    process.env.REACT_APP_API_URL + `product/varient`, data,
    {
      headers: multipartHeader(),
    }
  );
}

const deleteProductVariant = (productId, variantId) => {
  return axios.delete(process.env.REACT_APP_API_URL + `product/variant/${productId}/${variantId}`, {
    headers: authHeader(),
  });
};

/** B2B helper: GET /product/variant/:publicId/price-preview?qty= */
const variantPricePreview = (variantPublicId, params = {}) => {
  return axios.get(
    `${process.env.REACT_APP_API_URL}product/variant/${variantPublicId}/price-preview`,
    {
      headers: authHeader(),
      params,
    }
  );
};

const productServiceExport = {
  getAll,
  salegetAllProduct,
  get,
  create,
  update,
  updateStatus,
  deleteProduct,
  restore,
  restoreVariant,
  updateStock,
  updateVariant,
  deleteProductVariant,
  getVariant,
  getProductByBarcode,
  variantPricePreview,
};

export default productServiceExport;
